import {Component, Inject, OnInit, Optional, ChangeDetectionStrategy} from '@angular/core';
import {DateService} from '@softline/core';
import {RouterModule} from '@angular/router';

import {REGISTRATION_MODULE_CONFIG, RegistrationModuleConfig} from '../registration.shared';

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-registration',
    imports: [RouterModule,
    TranslatePipe],
    templateUrl: './registration.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {

  constructor(@Optional() @Inject(REGISTRATION_MODULE_CONFIG) readonly config: RegistrationModuleConfig
  ) { }

  ngOnInit(): void {
  }
}
